"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonDropdown = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _ui = require("../../ui");
require("../../../src/ui/buttonDropdown/buttonDropdown.module.scss");
var _uuid = require("uuid");
var _portal = require("../portal/portal");
var _selectListItem = require("../selectListItem/selectListItem");
var _selectList = require("../selectList/selectList");
const _excluded = ["children", "className", "directionVertical", "directionHorizontal", "disabled", "dontChangeFocus", "dropdownClassName", "isFitWindow", "isMoveToFit", "isScaleAnimation", "multiple", "notBlurClasses", "opened", "portal", "portalId", "portalSelector", "single", "beforeOpen", "onBlur", "onClick", "onOpen", "onClose", "onDirectionVerticalSet"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// accessibility ok

const ButtonDropdown = exports.ButtonDropdown = /*#__PURE__*/React.forwardRef((props, ref) => {
  let {
      children,
      className,
      directionVertical,
      directionHorizontal,
      disabled,
      dontChangeFocus,
      dropdownClassName,
      isFitWindow,
      isMoveToFit,
      isScaleAnimation,
      multiple,
      notBlurClasses,
      opened,
      portal,
      portalId,
      portalSelector,
      single,
      beforeOpen,
      onBlur,
      onClick,
      onOpen,
      onClose,
      onDirectionVerticalSet
    } = props,
    attributesOriginal = _objectWithoutProperties(props, _excluded),
    attributes = attributesOriginal,
    btn = null,
    list = null;
  let [directionHook, setDirectionHook] = React.useState(directionVertical);
  let [isOpenedHook, setIsOpenedHook] = React.useState(opened);
  let [dropdownStyle, setDropdownStyle] = React.useState({});
  const [uniqueClass] = React.useState('kui-button-dropdown--' + (0, _uuid.v4)());
  const _buttonRef = React.useRef(null);
  const buttonRef = (0, _utils.useCombinedRefs)(ref, _buttonRef);
  const buttonButtonRef = React.useRef(null);
  const dropdownRef = React.useRef(null);
  const dropdownUniqueClass = 'kui-button-dropdown__dropdown--' + uniqueClass;
  const timer = React.useRef(null);
  className = (0, _utils.ClassNames)('kui-button-dropdown', uniqueClass, disabled ? 'kui-button-dropdown--disabled' : null, isOpenedHook ? 'kui-button-dropdown--opened' : null, portal ? 'kui-button-dropdown--portal' : null, multiple && single ? 'kui-button-dropdown--single' : null, className);
  const classNameDropdown = (0, _utils.ClassNames)('kui-button-dropdown__dropdown', dropdownClassName ? dropdownClassName : null, dropdownUniqueClass);
  const calcDirection = didntFit => {
    const button = buttonRef.current.getBoundingClientRect();
    let portalRect = {
      bottom: window.innerHeight,
      left: 0,
      right: window.innerWidth,
      top: 0
    };
    if (directionVertical === 'auto') {
      directionHook = button.top > window.innerHeight * 1 / 2 ? 'up' : 'down';
      setDirectionHook(directionHook);
    }
    if (onDirectionVerticalSet) {
      onDirectionVerticalSet(directionHook);
    }
    let bottom = 0;
    let top = 0;
    if (portal) {
      const portalEl = document.getElementById(portalId);
      if (portalEl) {
        const portalStyle = window.getComputedStyle(portalEl);
        if (!isNaN(parseInt(portalStyle.top)) || !isNaN(parseInt(portalStyle.left))) {
          portalRect = portalEl.getBoundingClientRect();
        }
      }
      dropdownRef.current.style.top = 'unset';
      dropdownRef.current.style.bottom = 'unset';
      dropdownRef.current.style.left = 'unset';
      dropdownRef.current.style.right = 'unset';
      if (directionHorizontal === 'left') {
        dropdownRef.current.style.left = button.left - portalRect.left + 'px';
      } else {
        dropdownRef.current.style.right = portalRect.right - button.right + 'px';
      }
      if (directionHook === 'up') {
        bottom = portalRect.bottom - button.top;
      } else {
        top = button.bottom - portalRect.top;
      }
    }
    if (portal || isFitWindow) {
      let padding = _utils.SCREEN_PADDING * 2;
      let reserve = 0; // на сколько можно сдвинуть, чтобы избавиться от скролла в дропдауне
      if (didntFit) {
        if (directionHook === 'up') {
          reserve = window.innerHeight - button.top - (portalRect.bottom || padding);
        } else {
          reserve = button.bottom - (portalRect.bottom || padding);
        }
        if (reserve < didntFit) didntFit = reserve;
        if (didntFit) {
          if (bottom) bottom -= didntFit;
          if (top) top -= didntFit;
        }
      }
      let maxHeight = directionHook === 'up' ? button.top - (portalRect.top || padding) : window.innerHeight - button.bottom - (portalRect.bottom || padding);
      if (didntFit) {
        maxHeight += didntFit;
      }
      setDropdownStyle(_objectSpread(_objectSpread({}, dropdownStyle), {}, {
        maxHeight: Math.ceil(maxHeight) + 'px'
      }));
    }
    if (directionHook === 'up') {
      if (bottom) dropdownRef.current.style.bottom = bottom + 'px';
    } else {
      if (top) dropdownRef.current.style.top = top + 'px';
    }
  };
  const onDropdownMount = didntFit => {
    if (!dropdownRef.current) return;
    calcDirection(isFitWindow && isMoveToFit && portal && didntFit);
    if (multiple && single) {
      dropdownRef.current.removeEventListener('click', onDropdownClick);
      dropdownRef.current.addEventListener('click', onDropdownClick);
    }
  };
  const afterOpened = isOpened => {
    isOpenedHook = isOpened;
    setIsOpenedHook(isOpenedHook);
    if (isOpened) {
      const buttonDropdown = buttonRef.current;
      if (buttonDropdown && !dontChangeFocus) {
        // в сафари фокусится button dropdown и закрытие на blur не срабатывае
        const button = buttonDropdown.firstChild;
        if (button) button.focus();
      }
      if (onOpen) onOpen();
    } else if (isOpened === false) {
      if (onClose) onClose();
      setTimeout(() => {
        const activeElement = document.activeElement;
        if (activeElement.tagName === 'INPUT' || activeElement.tagName === 'BUTTON' || activeElement.tagName === 'TEXTAREA' || [...activeElement.attributes].find(attr => attr.name.startsWith('aria-'))) {
          // dont move focus, if it catched by another control
        } else if (buttonButtonRef.current) buttonButtonRef.current.focus(); // вернуть фокус кнопке
      });
    }
  };
  const setIsOpened = isOpened => {
    if (isOpened === isOpenedHook) return;
    if (isOpened && beforeOpen) {
      beforeOpen().then(() => afterOpened(isOpened));
    } else {
      afterOpened(isOpened);
    }
    if (isOpened) calcDirection();
  };
  attributes.onClick = e => {
    if (!(disabled && isOpenedHook)) {
      setIsOpened(!isOpenedHook);
    }
    if (onClick) onClick(e);
  };
  notBlurClasses = [...notBlurClasses, uniqueClass, dropdownUniqueClass];
  attributes.onBlur = e => {
    if (!document.hasFocus()) return;
    const classes = (0, _utils.getParentsClasses)(e.relatedTarget, notBlurClasses);
    for (let i = 0; i < notBlurClasses.length; i++) {
      if (classes.includes(notBlurClasses[i])) {
        return;
      }
    }
    setIsOpened(false);
    if (onBlur) onBlur(e);
  };
  attributes.onKeyDown = e => {
    if (!e) return;
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
      const ariaSelected = dropdownRef.current.querySelector('[tabindex]:not([tabindex="-1"])');
      if (ariaSelected) ariaSelected.focus();
    }
  };
  const onChange = e => {
    if (!multiple) {
      setIsOpened(false);
    }
    if (attributes.onChange) attributes.onChange(e);
  };
  let childrenArray =
  // children could be string, we need array
  Array.isArray(children) ? children : [children];
  list = React.Children.map(childrenArray, child => {
    if (!child || !child.props) return null;
    if (child.type.displayName === 'Button') {
      attributes.className = (0, _utils.ClassNames)('kui-button-dropdown__item', child.props.className), btn = /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({
        ['aria-haspopup']: true,
        ['aria-expanded']: isOpenedHook
      }, attributes), {}, {
        ref: buttonButtonRef
      }));
      return null;
    }
    if (child.type.displayName !== 'SelectList') return child;
    return /*#__PURE__*/React.cloneElement(child, {
      onChange
    });
  });
  const onKeyDown = e => {
    if (!e) return;
    if (e.key === 'Escape' || multiple && single && e.key === 'Enter' // чекбоксы меняются пробелом, а на Enter нужно применить и закрыть дропдаун
    ) {
      e.stopPropagation();
      return setIsOpened(false);
    }
  };
  React.useEffect(() => {
    setIsOpened(opened);
  }, [opened]);
  function onDropdownClick(e) {
    const classes = (0, _utils.getParentsClasses)(e.target, [_selectListItem.SELECT_LIST_ITEM_CLASS, _selectList.SELECT_LIST_CLASS]);
    if (classes.includes(_selectListItem.SELECT_LIST_ITEM_CLASS)) {
      timer.current = setTimeout(() => setIsOpened(false), 100); // close after onChange
    }
  }
  React.useEffect(() => {
    const dropdownRefCurrent = dropdownRef.current;
    return () => {
      if (dropdownRefCurrent) dropdownRefCurrent.removeEventListener('click', onDropdownClick);
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);
  const dropdownElement = /*#__PURE__*/React.createElement(_ui.Dropdown, {
    className: classNameDropdown,
    directionVertical: directionHook,
    directionHorizontal: directionHorizontal,
    isFitWindow: isFitWindow,
    isScaleAnimation: isScaleAnimation,
    opened: isOpenedHook,
    portal: portal,
    ref: dropdownRef,
    style: dropdownStyle,
    tabIndex: -1,
    onBlur: attributes.onBlur,
    onDidMount: onDropdownMount,
    onKeyDown: onKeyDown
  }, list);
  const dropdownPortal = portal ? /*#__PURE__*/React.createElement(_portal.Portal, {
    id: portalId,
    selector: portalSelector
  }, dropdownElement) : dropdownElement;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    ref: buttonRef,
    tabIndex: -1 // в сафари на десктопе и в мобилках в onBlur relatedTarget null, и закрыть на кнопку когда фокус в дропдауне не получается
  }, btn, dropdownPortal);
});
ButtonDropdown.defaultProps = {
  directionVertical: 'auto',
  directionHorizontal: 'left',
  disabled: false,
  notBlurClasses: [],
  portalId: _portal.KUI_PORTAL_ID,
  single: true
};
ButtonDropdown.displayName = 'ButtonDropdown';